import { render, staticRenderFns } from "./add-sample-product-component.vue?vue&type=template&id=48caa66d&scoped=true"
import script from "./add-sample-product-component.vue?vue&type=script&lang=js"
export * from "./add-sample-product-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48caa66d",
  null
  
)

export default component.exports